









































import CustomerContactCard from "@/components/partner/CustomerContactCard.vue";
import ThgChargingStationCard from "@/components/thg/ThgChargingStationCard.vue";
import { ITemplateContext } from "@/lib/interfaces/template/templateContext.interface";
import { detailedDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import { ThgPortalModule } from "@/store/modules/thg.portal.store";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import "vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css";
import { Component, Prop } from "vue-property-decorator";
import TemplateDialog from "../template/TemplateDialog.vue";

@Component({
  components: {
    CustomerContactCard,
    ThgChargingStationCard,

    TemplateDialog
  }
})
export default class ThgChargingStationDetailCard extends DarkModeHighlightMixin {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  displayToDetailView!: boolean;

  get selectedChargingStation() {
    return ThgPortalModule.selectedChargingStation;
  }

  get meterReadings() {
    return ThgPortalModule.meterReadingForChargingStation;
  }

  get isSelectedChargingStation() {
    return "id" in this.selectedChargingStation;
  }

  get allChargingStations() {
    return ThgPortalModule.allChargingStations;
  }

  get selectedUser() {
    return UserAdministrationModule.selectedUser;
  }

  get fullname() {
    return UserAdministrationModule.selectedUser.firstName + " " + UserAdministrationModule.selectedUser.lastName;
  }

  get to() {
    return [UserAdministrationModule.selectedUser.contact.email];
  }

  toDetailView() {
    this.$router.push({
      name: "ThgChargingStationDetailView",
      params: { chargingStationId: this.selectedChargingStation.id }
    });
  }

  get createdDate() {
    return this.date(this.selectedChargingStation);
  }

  date(item: any) {
    if (item.timestamp.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(item.timestamp.created, locale);
    }
    return "";
  }

  async loadPartners() {
    if (PartnerModule.partners.length === 0) {
      await PartnerModule.getPartners();
    }
  }

  async loadContext(): Promise<ITemplateContext> {
    const context: ITemplateContext = {};

    // TODO

    return context;
  }

  async mounted() {
    this.loadPartners();
  }
}
